import CloseIcon from "@mui/icons-material/Close";
import { Box, Grid, Tab, Tabs } from "@mui/material";
import { useEffect, useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { setCountryOptions } from "../../actions";
import { showInfoSwal, showWarningSwal } from "../../functions/alert";
import { makeSureIsArray } from "../../functions/general";
import { getCountries, getOrganizations } from "../../functions/getData";
import { addCompetitionOrganization } from "../../functions/postData";
import NunitoText from "../general/NunitoText";
import ReusableAutocompleteWithID from "../general/ReusableAutocompleteWithID";
import ReusableButton from "../general/ReusableButton";
import ReusableToggle from "../general/ReusableToggle";
const startColumnFlexStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
};
const centerFlexStyle = { display: "flex", alignItems: "center" };
function EachForm({
  forms,
  setForms,
  count,
  competition,
  organizationOptions,
  setOrganizationOptions,
}) {
  const { organization, country, translate, edit_sessions } = forms[count];
  const allCountryOptions = useSelector((state) => state.countryOptions);
  const languageOptions = useSelector((state) => state.languageOptions);
  const updateForm = (identifier, value) => {
    let newForms = [...forms];
    newForms[count][identifier] = value;
    if (identifier === "country") {
      newForms[count].organization = "";
      setOrganizationOptions(value);
    }
    setForms(newForms);
  };
  let filteredOrgUsers = (users) =>
    Array.isArray(users)
      ? users.filter((u) => u.role_id === 2 && u.status === "active")
      : [];
  let countries = [
    ...new Set(
      filteredOrgUsers(
        organizationOptions.find((o) => o.id === organization)?.users
      ).map((u) => u.country_id)
    ),
  ];
  let takenCountries = forms
    .filter((p, i) => i !== count)
    .map((f) => ({ organization_id: f.organization, country_id: f.country }));
  let alreadyJoinedCountries = competition.competition_organization.map(
    (o) => ({ organization_id: o.organization_id, country_id: o.country_id })
  );
  let cannotJoin = [takenCountries, alreadyJoinedCountries]
    .flat()
    .filter(
      (value, i, self) =>
        i ===
        self.findIndex(
          (t) =>
            t.organization_id === value.organization_id &&
            t.country_id === value.country_id
        )
    );
  let filteredCountryOptions = allCountryOptions.filter(
    (c) =>
      countries.includes(c.id) &&
      (!cannotJoin.find(
        (t) => t.organization_id === organization && t.country_id === c.id
      ) ||
        c.id === country)
  );
  const containerStyle = { padding: 40 };
  // const radioStyle = { color: 'var(--color-text)' }
  // const competitionModeWrapperStyle = { display: 'flex', alignItems: 'center', marginTop: 20 }
  console.log(filteredCountryOptions, allCountryOptions, countries);

  return (
    <Grid
      container
      alignItems="center"
      justifyContent="space-between"
      style={containerStyle}
    >
      <ReusableAutocompleteWithID
        type="withLabel"
        width={280}
        placeholder="Country*"
        state={country}
        setState={updateForm}
        target="country"
        borderColor="var(--color-border-strong)"
        required
        options={allCountryOptions.map((r) => ({
          id: r.id,
          option: r.display_name,
        }))}
      />
      <ReusableAutocompleteWithID
        type="withLabel"
        width={280}
        placeholder="Organization*"
        state={organization}
        setState={updateForm}
        target="organization"
        borderColor="var(--color-border-strong)"
        required
        options={organizationOptions.map((o) => ({ id: o.id, option: o.name }))}
        grayedOut={!country}
        readOnly={!country}
      />
      <ReusableAutocompleteWithID
        type="withLabel"
        width={460}
        placeholder="Translation"
        state={translate}
        setState={updateForm}
        multiple
        target="translate"
        borderColor="var(--color-border-strong)"
        options={languageOptions.map((l) => ({ id: l.id, option: l.name }))}
      />
      {/* <div style={competitionModeWrapperStyle}>
                <NunitoText value='Mode of Competition:' fontSize={18} fontWeight={600} italic />
                <RadioGroup value={competition_mode} style={{ marginLeft: 20 }} onChange={e => updateForm('competition_mode', e.target.value)}>
                    <Grid container>
                        <FormControlLabel value='0' control={<Radio style={radioStyle} />} label="Paper Based" />
                        <FormControlLabel value='1' control={<Radio style={radioStyle} />} label="Online" />
                        <FormControlLabel value='2' control={<Radio style={radioStyle} />} label="Both" />
                    </Grid>
                </RadioGroup>
                <ReusableButton text='Clear Selection' color='var(--color-text)' borderColor='var(--color-border-strong)' fontSize={16} marginRight={20}
                    onClick={() => updateForm('competition_mode', '')} />
            </div> */}
      <div style={startColumnFlexStyle}>
        <NunitoText
          value="Allow Session Edits By Partners"
          fontSize={16}
          fontWeight={600}
          italic
        />
        <ReusableToggle
          type="text"
          width={160}
          falseValue="No"
          trueValue="Yes"
          state={edit_sessions}
          setState={updateForm}
          target="edit_sessions"
        />
      </div>
    </Grid>
  );
}
const boxStyle = { width: 1400, minHeight: 400, maxHeight: "90%" };
const addCountryButtonDivStyle = {
  display: "flex",
  justifyContent: "flex-end",
  marginTop: -45,
  marginRight: 20,
};
const divStyle = {
  borderRadius: 10,
  margin: "20px 20px 0 20px",
  boxShadow: "0px 1px 6px rgb(0,0,0,0.2), 0 1px 6px rgb(0,0,0,0.2)",
};
const tabPropsStyle = { height: 0 };
const tabStyle = (value, i) => ({
  color: value !== i && "var(--color-text-secondary)",
  backgroundColor: value !== i && "var(--simcc-grey-150)",
  border: value === i && "1px solid var(--color-border)",
  boxShadow:
    value === i && "0px 1px 6px rgb(0,0,0,0.2), 0px 1px 6px rgb(0,0,0,0.2)",
  borderRadius: "10px 10px 0 0",
  textTransform: "none",
  marginRight: 10,
  height: 40,
});
const iconStyle = {
  position: "relative",
  left: 12,
  height: 18,
  width: 18,
  color: "var(--color-text-secondary)",
};
const buttonsContainerStyle = { paddingInline: 60, marginBlock: 30 };
export default function AddParticipatingCountryModal({
  setLoading,
  table,
  id,
  cancelAddCompetitionOrganization,
  afterAddingCompetitionOrganization,
}) {
  const isMounted = useRef(false);
  const [forms, setForms] = useState([
    {
      id: 1,
      organization: "",
      country: "",
      edit_sessions: false,
      competition_mode: "0",
      translate: [],
    },
  ]);
  const [value, setValue] = useState(0);
  const [organizationOptionsMap, setOrganizationOptionsMap] = useState({});
  const competition = makeSureIsArray(table.data).find((c) => c.id === id);
  const addForm = () => {
    if (forms.length >= 12) return showInfoSwal("Maximum number of tab is 12");
    const newFormId =
      forms.map((f) => f.id).reduce((a, b) => Math.max(a, b), 0) + 1;
    setForms([
      ...forms,
      {
        id: newFormId,
        organization: "",
        country: "",
        edit_sessions: false,
        competition_mode: "0",
        translate: [],
      },
    ]);
    setValue(forms.length);
  };
  const deleteForm = (e, id) => {
    e.stopPropagation();
    let newForms = forms.filter((f) => f.id !== id);
    if (!newForms.length) return cancelAddCompetitionOrganization();
    let index = forms.findIndex((f) => f.id === id);
    if (value === forms.length - 1 || index < value) setValue(value - 1);
    setForms(newForms);

    // Clean up organization options for deleted form
    setOrganizationOptionsMap((prev) => {
      const newMap = { ...prev };
      delete newMap[id];
      return newMap;
    });
  };
  const handleChange = (e, newValue) => setValue(newValue);

  const updateOrganizationOptionsForForm = (formId, countryId) => {
    if (!countryId) {
      setOrganizationOptionsMap((prev) => ({
        ...prev,
        [formId]: [],
      }));
      return;
    }

    getOrganizations(`?limits=100&status=active&country_id=${countryId}`).then(
      (u) => {
        setOrganizationOptionsMap((prev) => ({
          ...prev,
          [formId]: u.OrganizationLists.data.map((d) => ({
            id: d.id,
            name: d.name,
            users: d.users,
          })),
        }));
      }
    );
  };
  const onSubmit = () => {
    let payload = { competition_id: id, organizations: [] };
    let msg = "";
    for (let i = 0; i < forms.length; i++) {
      const {
        organization,
        country,
        edit_sessions,
        competition_mode,
        translate,
      } = forms[i];
      let warningMessage = "";
      if (organization === "")
        warningMessage += "Please select organization.<br>";
      if (country === "") warningMessage += "Please select country.<br>";
      if (!warningMessage) {
        payload.organizations.push({
          organization_id: organization,
          country_id: country,
          edit_sessions: Number(edit_sessions),
          competition_mode: Number(competition_mode),
          translate: JSON.stringify(translate),
        });
      } else {
        msg += "<div>";
        msg += `<div style="text-align:center; font-weight: 800">Error in Organization ${
          i + 1
        }</div>`;
        msg += `<div style="text-align:left">${warningMessage}</div>`;
        msg += "</div>";
      }
    }
    if (msg) return showWarningSwal(msg);
    setLoading(true);
    console.log(JSON.stringify(payload));
    addCompetitionOrganization(payload)
      .then((d) => {
        isMounted.current && setLoading(false);
        afterAddingCompetitionOrganization(
          cancelAddCompetitionOrganization,
          d,
          payload.organizations.map((d) => ({
            ...d,
            organization_name:
              Object.values(organizationOptionsMap)
                .flat()
                .find((o) => o.id === d.organization_id)?.name || "",
          }))
        );
      })
      .catch((e) => console.log(e))
      .finally(() => isMounted.current && setLoading(false));
  };

  const controller = useMemo(() => new AbortController(), []);
  const signal = controller.signal;
  useEffect(() => {
    isMounted.current = true;
    getCountries("?limits=100&status=active", signal)
      .then((u) =>
        setCountryOptions(
          u.OrganizationLists.data.map((d) => ({
            id: d.id,
            name: d.name,
            users: d.users,
          }))
        )
      )
      .catch((e) => console.log(e));
    return () => {
      controller.abort();
      isMounted.current = false;
    };
  }, [controller, signal]);
  return (
    <Box className="popUpModal horizontalScrollable" style={boxStyle}>
      <div>
        <NunitoText
          value={`ADD PARTICIPATING COUNTRIES`}
          fontSize={30}
          fontWeight={600}
          color="var(--color-primary)"
          marginTop={20}
        />
        <div style={addCountryButtonDivStyle}>
          <ReusableButton
            text="Add another participating country"
            fontSize={15}
            height={40}
            bgColor="var(--color-primary)"
            iconType="add"
            onClick={() => addForm()}
            allowSpam
          />
        </div>
      </div>
      <div style={divStyle}>
        <Tabs
          value={value}
          onChange={handleChange}
          TabIndicatorProps={{ style: tabPropsStyle }}
          variant="scrollable"
          scrollButtons
        >
          {forms.map((f, i) => (
            <Tab
              key={f.id}
              label={
                <div style={centerFlexStyle}>
                  Country {i + 1}
                  <CloseIcon
                    style={iconStyle}
                    onClick={(e) => deleteForm(e, f.id)}
                  />
                </div>
              }
              style={tabStyle(value, i)}
            />
          ))}
        </Tabs>
        <EachForm
          forms={forms}
          setForms={setForms}
          count={value}
          setOrganizationOptions={(countryId) =>
            updateOrganizationOptionsForForm(forms[value].id, countryId)
          }
          competition={competition}
          organizationOptions={organizationOptionsMap[forms[value].id] || []}
        />
      </div>
      <Grid
        container
        justifyContent="space-evenly"
        style={buttonsContainerStyle}
      >
        <ReusableButton
          text="Cancel"
          fontSize={22}
          height={60}
          width={300}
          bgColor="var(--color-surface)" color="var(--color-primary)" borderColor="var(--color-border-strong)"
          onClick={() => cancelAddCompetitionOrganization()}
        />
        <ReusableButton
          text="Submit"
          fontSize={22}
          height={60}
          width={300}
          bgColor="var(--color-primary)"
          onClick={() => onSubmit()}
        />
      </Grid>
    </Box>
  );
}
